export default __webpack_public_path__ + "static/media/blog-img213.174fca76.jpg";